var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAuthourizedPerson({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#F4F4F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 15.5385C20.1472 15.5385 18.6452 17.0308 18.6452 18.8718C18.6452 20.7127 20.1472 22.2051 22 22.2051C23.8528 22.2051 25.3548 20.7127 25.3548 18.8718C25.3548 17.0308 23.8528 15.5385 22 15.5385ZM17.0968 18.8718C17.0968 16.1812 19.292 14 22 14C24.708 14 26.9032 16.1812 26.9032 18.8718C26.9032 21.5624 24.708 23.7436 22 23.7436C19.292 23.7436 17.0968 21.5624 17.0968 18.8718ZM15.5944 32.4615H28.4056C28.0232 29.2839 25.3011 26.8205 22 26.8205C18.6989 26.8205 15.9768 29.2839 15.5944 32.4615ZM14 33.2308C14 28.8408 17.5817 25.2821 22 25.2821C26.4183 25.2821 30 28.8408 30 33.2308C30 33.6556 29.6534 34 29.2258 34H14.7742C14.3466 34 14 33.6556 14 33.2308Z",
    fill: "#23242A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.0801 21.2197C34.373 21.5126 34.373 21.9874 34.0801 22.2803L30.0801 26.2803C29.7872 26.5732 29.3124 26.5732 29.0195 26.2803L27.0195 24.2803C26.7266 23.9874 26.7266 23.5126 27.0195 23.2197C27.3124 22.9268 27.7872 22.9268 28.0801 23.2197L29.5498 24.6893L33.0195 21.2197C33.3124 20.9268 33.7872 20.9268 34.0801 21.2197Z",
    fill: "#23242A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAuthourizedPerson);
export default __webpack_public_path__ + "static/media/icon-authourized-person.2b06fda4283de37381e71d19a3a11f9e.svg";
export { ForwardRef as ReactComponent };